/* eslint no-console:0 */
// Pack da página de venda alternativa (LandingController#show). Sem React:
// a página é HTML do servidor + este JS, para carregar o mais leve possível.
import '../lp/lp.css';
import startLanding from '../lp';

// Sentry só carrega onde o layout montou a config (production), e fora do
// bundle principal para não pesar no primeiro carregamento.
if (window.SENTRY_CONFIG) {
  import(/* webpackChunkName: "lp-sentry" */ '../helpers/initSentry')
    .then((module) => module.default())
    .catch(() => {});
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => startLanding(window.__LP__));
} else {
  startLanding(window.__LP__);
}
